import React from "react";
import "../../styles/Modal.scss";


const Modal = ({ children }) => {
    return (
        <React.Fragment>
            <div className="modal">
                {children}
            </div>
        </React.Fragment>
    )
};

export default Modal;